require('../../../retail/shared/wdh-legacy/image-spot/js/base/component-image-spot.js');
(function ($) {
  window.DGS.OnLoad.getInstance().register(function () {
    $('.component.image-spot.square-spot').each(function (i) {
      var $thisSquareSpot = $(this);
      var $thisImageSpotElementLink = $thisSquareSpot.find('.image-spot-element-link');
      $thisImageSpotElementLink.each(function () {
        var $thisLink = $(this);
        var $deepestChild = $thisLink.siblings('.image-spot-element-header').children(),
          $next = $deepestChild;

        // find the last child of image spot element header
        while ($next.length) {
          $deepestChild = $next;
          $next = $next.children();
        }
        $deepestChild.addClass('clickable').on('click', function () {
          location.href = $thisLink.find('a').attr('href');
        });
      });
    });
    $('.component.as-tab.image-spot, .component.as-faq.image-spot').each(function () {
      var $tabs = $(this).find('.image-spot-elements'),
        $firstTab = $tabs.children('li:first-child'),
        $componentContent = $firstTab.closest('.component-content'),
        $container = $('.context-container', $componentContent),
        $content = $('.image-spot-element-context', $firstTab);

      // by default display content opf the first tab
      if ($firstTab.length != 0) {
        $firstTab.addClass('active');
        if (!$container.length) {
          $container = $('<div class="context-container"></div>');
          $componentContent.append($container);
          $container.html($content.html());
        }
      }

      // append title and description to clickable tab
      $.each($tabs.children('.image-spot-element'), function () {
        var $link = $(this).children('a'),
          $header = $(this).children('.image-spot-element-header');
        $link.append($header);
      });
      window.DGS.Resizer.getInstance().register(function () {
        window.DGS.EqualHeight.getInstance().register($tabs.find('.image-spot-element-image'), false);

        // make tab heights equal for non mobile
        if ($(window).width() > 601) {
          // desktop
          window.DGS.EqualHeight.getInstance().register($tabs.children('.image-spot-element'), false);
        } else {
          $tabs.children('.image-spot-element').css('height', 'auto');
        }
      });
    });
    $('.component.image-spot.text-link-under-image .image-spot-element').each(function () {
      var $origLink = $('.image-spot-element-link', $(this));
      $(this).children('a').append($origLink);
    });
    $('.image-spot.as-slider').each(function () {
      var $timeInterval,
        $rotateSlides,
        $currentIndex = 0,
        $slides = $(this).find('.image-spot-elements'),
        $tabs,
        $tabsHtml = "<div class='slider-tabs'><div class='tabs-content'>",
        $overlayHtml = "<div class='slider-overlay'></div>",
        $timeInterval = -1,
        $initiaInterval = -1,
        $slideInterval = 12000;

      // move text inside a slide
      $.each($slides.children('.image-spot-element'), function () {
        var $imgContainer = $(this).find('.image-spot-element-image');
        // $imgContainer.unwrap();
        var $text = $(this).children('.image-spot-element-text');
        $tabsHtml += "<div class='slider-tab'></div>";
        $imgContainer.append($overlayHtml);
        $imgContainer.append($text);
        $imgContainer.find('.image-spot-element-text').wrap("<div class='slide-content'></div>");
      });
      $tabsHtml += '</div></div>';

      // create slider tabs
      $($tabsHtml).insertAfter($slides);
      $tabs = $(this).find('.slider-tabs');
      $rotateSlides = function $rotateSlides() {
        // hide old
        $slides.children('.image-spot-element.active-slide').fadeOut(700);
        setTimeout($markInactive, 300);
        setTimeout($setActive, 600);
        if ($currentIndex == $slides.children('.image-spot-element').length) {
          $currentIndex = 1;
        } else {
          $currentIndex++;
        }
      };
      var $markInactive = function $markInactive() {
        $(this).removeClass('active-slide');
        $tabs.find('.slider-tab.active-tab').removeClass('active-tab');
      };
      var $setActive = function $setActive() {
        // mark and show active
        $slides.children(".image-spot-element:nth-child(".concat($currentIndex, ")")).fadeIn(1200);
        setTimeout($markActive, 600);

        // set height
        $slides.height($slides.children(".image-spot-element:nth-child(".concat($currentIndex, ")")).height());
      };
      var $markActive = function $markActive() {
        $slides.children(".image-spot-element:nth-child(".concat($currentIndex, ")")).addClass('active-slide');
        $tabs.find(".slider-tab:nth-child(".concat($currentIndex, ")")).addClass('active-tab');
      };
      $('.slider-tab').click(function () {
        // stop the interval rotation
        window.clearInterval($timeInterval);
        $currentIndex = $tabs.find('.slider-tab').index($(this));
        $rotateSlides();
      });
      var initSlider = function initSlider() {
        $currentIndex = 0;
        window.clearInterval($timeInterval);

        // mark first as active
        $rotateSlides();

        // start interval rotation
        $timeInterval = setInterval($rotateSlides, $slideInterval);
      };
      initSlider();
      $(window).resize(function () {
        clearTimeout($initiaInterval);
        $initiaInterval = setTimeout(initSlider, 100);
      });
    });
    window.DGS.Resizer.getInstance().register(function () {
      $('.image-spot.square-spot').each(function () {
        var $this = $(this);
        // Set the height as like image spot element header
        $('.image-spot-element-link', $this).each(function () {
          $(this).height($(this).closest('li.image-spot-element').find('.image-spot-element-header').height());
        });
      });
    });
  });
})(jQuery);